<template>
	<div style="min-height: 100vh;">
		<div style="text-align: center;">
			<div class="panel">
				<div class="panel-header" style="display: flex;justify-content: space-between;">
					<div>
						
						{{main.StoreName}} (<span v-if="main.Deadline>0">剩余{{main.Deadline}}天</span><span v-else>剩余{{main.Remainingtimes}}次</span>)
					</div>
				</div>
				<div class="panel-body" style="min-height: 400px;">
					<div style="display: flex;justify-content: space-between;">
						<div style="flex: 1;font-size: 18px;line-height: 2.0;">
							<div>
								<img src="https://bikecdn.typhcl.cn/L/md_xf.png" style="width: 200px;height: 200px;" />
							</div>
							<div>
								请先扫码缴存
							</div>
							<div>
								为提升转换率,用户无需在小程序下单<br>
								故客人到店后，相关费用由门店线下直接收取，<br>平台服务费可由门店按次缴存，<br>
								<span style="color: red;">限时活动:新店缴纳入驻服务费1999元，赠送一年不限次的平台使用费。</span><br>								
							</div>
							
						</div>
						<div style="flex: 1;font-size: 18px;line-height: 2.0;">
							<div>
								<img src="https://bike.typhcl.cn/md/imgs/md_qr.jpg" style="height: 200px;" />
							</div>
							<div>
								如需帮助或<br>
								需要申请试用。
							</div>
							<div>
								请添加客服微信，备注门店
							</div>
						</div>
					</div>
					<div style="text-align: center;margin-top: 40px;">
						<button class="btn btn-success mr-10" @click="backs">返回</button>
						<button class="btn btn-primary mr-10" @click="init">刷新</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				// 在这里定义你的组件数据
				src: "",
				list: [],
				main: {
					Deadline: 0,
					Remainingtimes: 0
				}
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			// 方法
			backs(){
				var that=this
				history.back(-1);
			},
			init() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "msg_init",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						that.$data.main = e.main;
					}
				})
				$.ajax({
					url: that.URL,
					data: {
						t: "md_kh",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						that.list = e.list;
					}
				})
			}
		},
		mounted() {
			var that = this
			// 组件挂载后执行的代码
			that.init()
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}
</style>